import { useEffect, useRef } from "react";

// import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { isServer } from "../../utils/auth";

// import { LOCALES } from "../../constants/APIKeys";
// const LANGUAGE_KEY = "_language";
export const BinotelScriptLoader = ({ binotelId }) => {
  const pollingIntervalRef = useRef(null);
  const timeoutIdRef = useRef(null);
  // const router = useRouter();
  // const { pathname } = router;
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    if (isServer()) return;

    const WIDGET_SCRIPT_ID = "binotel-widget";
    const AUX_SCRIPT_SRC_PREFIX = "//widgets.binotel.com/getcall/js/getcall_utf-8.js?modifiedAt=";
    const PHONE_BUTTON_ELEMENT_ID = "bingc-phone-button";
    const GET_CALL_WIDGET_ELEMENT_ID = "getCallWidget";
    // const TRACING_SCRIPT_SRC_PREFIX = "//widgets.binotel.com/calltracking/js/information-about-the-visitor.js?modifiedAt=";

    const cleanupScripts = () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
        pollingIntervalRef.current = null;
      }

      if (window.BinotelGetCall && typeof window.BinotelGetCall === "object") {
        const widgetIds = Object.keys(window.BinotelGetCall);
        if (widgetIds.length > 0) {
          console.log("Found Binotel widget IDs:", widgetIds.join(", "));
          widgetIds.forEach((id) => {
            try {
              delete window.BinotelGetCall[id];
            } catch (error) {
              console.error(`Error deleting window.BinotelGetCall[\${id}]:`, error);
            }
          });
        }
      }
      const widgetScript = document.getElementById(WIDGET_SCRIPT_ID);
      if (widgetScript) {
        widgetScript.remove();
      }

      const scripts = document.querySelectorAll("script");
      scripts.forEach((script) => {
        // if (script.src && script.src.includes(TRACING_SCRIPT_SRC_PREFIX)) {
        //   script.remove();
        // }

        if (
          (script.src &&
            (script.src.includes(AUX_SCRIPT_SRC_PREFIX) ||
              script.src.includes("binotel.com") ||
              script.src.includes("binotel") ||
              script.src.includes("bingc"))) ||
          (script.id && (script.id.includes("binotel") || script.id.includes("bingc")))
        ) {
          script.remove();
        }
      });

      const potentialBinotelSelectors = [
        `#${PHONE_BUTTON_ELEMENT_ID}`,
        `#${GET_CALL_WIDGET_ELEMENT_ID}`,
        ".binotel-widget",
        ".bingc-widget",
        ".binotel-popup",
        ".bingc-modal",
        ".bingc-overlay",
        '[id^="binotel"]',
        '[class*="binotel"]',
        '[id^="bingc"]',
        '[class*="bingc"]',
        "[data-binotel]",
        "[data-bingc]",
      ];

      potentialBinotelSelectors.forEach((selector) => {
        try {
          document.body.querySelectorAll(selector).forEach((el) => {
            // Дополнительная проверка, что элемент все еще в DOM и не является body/html
            if (el && document.body.contains(el) && el !== document.body && el !== document.documentElement) {
              el.remove();
            }
          });
        } catch (e) {
          console.error(`Error during cleanup using selector "${selector}":`, e);
        }
      });

      // const phoneButtonElement = document.getElementById(PHONE_BUTTON_ELEMENT_ID);
      // if (phoneButtonElement) {
      //   phoneButtonElement.remove();
      // }
    };

    cleanupScripts();

    const addBinotelScript = () => {
      const script = document.createElement("script");
      // const sn = document.getElementsByTagName("script")[0];
      script.id = WIDGET_SCRIPT_ID;
      script.type = "text/javascript";
      script.async = true;
      script.src = `//widgets.binotel.com/getcall/widgets/${binotelId}.js`;

      document.body.appendChild(script);
      // sn.parentNode.insertBefore(script, sn);
    };

    if (binotelId) {
      timeoutIdRef.current = setTimeout(addBinotelScript, 1000);
    }

    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
        timeoutIdRef.current = null;
      }
      cleanupScripts();
    };
  }, [binotelId]);

  return null;
};
